export const messageDisplayTypes = [
	"isUserLockedOut",
	"isOasisLockedOut",
	"isSessionExpired",
	"isSessionTerminated",
	"isBlocked",
	"isActivatingAccount",
	"isAutomaticLogout",
	"isTooManyAttempts",
];

export function checkLoginStatusMessage(): string | undefined {
	const searchParams = new URLSearchParams(window.location.search);
	const paramsArray = Array.from(searchParams.keys());

	return paramsArray.find((el) => messageDisplayTypes.includes(el));
}
